import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Link } from "react-router-dom";
export class SecondFooter extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.props.actions.fetchGetAdDefault();
  }
  render() {
    const { fetchGetAdDefaultSuccess } = this.props.common;
    if (!fetchGetAdDefaultSuccess) return null;
    let Data = fetchGetAdDefaultSuccess;
    if (Data.Valid === 0) return null;
    return (
      <div className="common-second-footer">
        <div className={`footer_top footer_top_bg${Data.BackColor}`}>
          <div className='footer_topView'>
            {
              Data.ListAD.map(item => {

                if (item.Valid !== 1) return null;
                return (
                  <div className='footer_item' key={item.ID}>
                    <img alt="" style={{ width: "60px", height: "58px", marginRight: "27px", }} src={item.Picture} />
                    <div>
                      <h4>{item.Title}</h4>
                      {
                        item.ADdetailList && item.ADdetailList.map(it => {
                          if (it.Valid !== 1) return null;
                          if (it.URL) {
                            return (
                              <p key={it.ID}>
                                {
                                  it.UrlType === 0 ? <a href={it.URL} target="_blank">
                                    {it.Title}
                                  </a> : <Link to={it.URL} target="_self">
                                      {it.Title}
                                    </Link>
                                }
                              </p>
                            )
                          } else {
                            return (
                              <p key={it.ID}>
                                {it.Title}
                              </p>
                            )
                          }
                        })
                      }
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SecondFooter);



// WEBPACK FOOTER //
// ./src/features/common/SecondFooter.js